import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SettingsPopoverPage } from './settings-popover';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";

@NgModule({
  declarations: [
    SettingsPopoverPage,
  ],
    imports: [
        IonicPageModule.forChild(SettingsPopoverPage),
        PipesModule,
    DirectivesModule,

    DirectivesModule,

    ],
    providers: [
        ContentTranslationProvider
    ]
})
export class SettingsPopoverPageModule {}



// WEBPACK FOOTER //
// ./src/pages/settings-popover/settings-popover.module.ts